import { format, isToday, parseISO } from 'date-fns';
import { JobBlock } from './JobBlock';
import type { CalendarSlot } from '../../stores/calendarStore';

interface DayCellProps {
  date: Date;
  slots: CalendarSlot[];
}

export function DayCell({ date, slots }: DayCellProps) {
  const today = isToday(date);
  const sorted = [...slots].sort(
    (a, b) => a.scheduled_at.localeCompare(b.scheduled_at)
  );

  return (
    <div
      className={`bg-bg-secondary rounded-lg p-2 min-h-[300px] ${
        today ? 'border border-accent-purple/30' : 'border border-border-subtle'
      }`}
    >
      <div className="mb-2 text-center">
        <div className={`text-xs ${today ? 'text-accent-purple font-semibold' : 'text-text-muted font-medium'}`}>
          {format(date, 'EEE')}
        </div>
        <div className={`text-sm ${today ? 'text-accent-purple font-semibold' : 'text-text-primary font-medium'}`}>
          {format(date, 'd')}
        </div>
      </div>

      {sorted.length > 0 ? (
        sorted.map((slot) => (
          <JobBlock
            key={`${slot.job_id}-${slot.scheduled_at}`}
            slot={slot}
          />
        ))
      ) : (
        <p className="text-xs text-text-muted text-center mt-4">No jobs</p>
      )}
    </div>
  );
}

export default DayCell;
